/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationRoleModel } from '../../models/organization-role-model';

export interface OrganizationRolePost$Params {
      body?: OrganizationRoleModel
}

export function organizationRolePost(http: HttpClient, rootUrl: string, params?: OrganizationRolePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, organizationRolePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<string>;
    })
  );
}

organizationRolePost.PATH = '/OrganizationRole';
